export const serviceRequestAppName = 'Request Management';
export const applicationRole = {READ_ONLY: false , FULL_ACCESS: true};
